import classNames from "classnames";
import { LoaderIcon } from "./fancyIcons";
import React from "react";

const loaderContainerClasses = classNames(
  "tw-stroke-fay-400",
  "tw-fill-fay-400",
  "tw-flex",
  "tw-flex-col",
  "tw-justify-center",
  "tw-items-center",
  "tw-size-full",
  "tw-w-full",
  "tw-h-screen",
);

const loaderSvgClasses = classNames("tw-animate-spin");
const PageLoadingSpinner = ({
  loadingMessage,
}: {
  loadingMessage?: string;
}) => {
  return (
    <div className={loaderContainerClasses}>
      <LoaderIcon className={loaderSvgClasses} />
      {loadingMessage && (
        <div className="tw-max-w-48 tw-animate-pulse tw-pt-4 tw-text-center tw-text-gray-300">
          {loadingMessage}
        </div>
      )}
    </div>
  );
};

export default PageLoadingSpinner;
